import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Route, Switch } from 'react-router'
import BackgroundPage from 'src/components/BackgroundPage/BackgroundPage'
import NotFoundBackgroundPageContent from 'src/components/NotFoundBackgroundPageContent/NotFoundBackgroundPageContent'
import Subnav, { SubnavDesign } from 'src/components/Subnav/Subnav'
import TitleHeader from 'src/components/TitleHeader/TitleHeader'
import Topnav from 'src/components/Topnav/Topnav'
import Trns from 'src/localization/Trns'
import PeopleAppRoute from 'src/navigation/appRoutes/people.appRoute'
import { Rdrct } from 'src/navigation/Lnk'
import { peopleInvitedToOrgUrl, peopleMembersUrl } from 'src/navigation/urls'
import { selectUserListModelFromState } from 'src/redux/selectors/auth.selectors'
import { selectUserExplicitOrganizationListModelFromState } from 'src/redux/selectors/data/organizations.selectors'
import {
  selectCalculatedBackgroundLocation,
  selectPeopleInvitedToOrgMatch,
  selectPeopleMembersMatch,
} from 'src/redux/selectors/router.selectors'
import { css } from 'styled-components'

const People: React.FC = () => {
  const calculatedBackgroundLocation = useSelector(
    selectCalculatedBackgroundLocation,
  )
  const peopleMembersMatch = useSelector(selectPeopleMembersMatch)
  const peopleInvitedToOrgMatch = useSelector(selectPeopleInvitedToOrgMatch)
  const currentUser = useSelector(selectUserListModelFromState)
  const organization = useSelector(
    selectUserExplicitOrganizationListModelFromState,
  )

  const subnavOptions = useMemo(() => {
    const baseOptions = [
      ...(currentUser?.isInExplicitOrg &&
      (organization?.memberListVisible ||
        currentUser?.hasOrgCardManagerPermissions)
        ? [
            {
              label: <Trns source={'Organization Members'} />,
              to: peopleMembersUrl(),
              isActive: peopleMembersMatch !== null,
              ariaLabelSource: 'Organization Members',
            },
          ]
        : []),
    ]

    return currentUser?.hasOrgAdminPermissions
      ? [
          ...baseOptions,
          {
            label: <Trns source={'Invited To Org'} />,
            to: peopleInvitedToOrgUrl(),
            isActive: peopleInvitedToOrgMatch !== null,
            ariaLabelSource: 'Invited To Org',
          },
        ]
      : [...baseOptions]
  }, [peopleMembersMatch, peopleInvitedToOrgMatch])

  return (
    <BackgroundPage>
      <Topnav
        titleElements={{
          scrollContent: (
            <span
              css={css`
                ${getFontCss(
                  14,
                  themeConstants.colors.font_primary,
                  styleConstants.fontFamilies.medium,
                )};
              `}
            >
              <Trns source={'People'} />
            </span>
          ),
        }}
      />
      <TitleHeader title={<Trns source={'People'} />} />
      <Subnav
        design={SubnavDesign.Header}
        options={currentUser?.isInExplicitOrg ? subnavOptions : []}
      />
      <Switch location={calculatedBackgroundLocation}>
        {PeopleAppRoute.subRoutes.map((route, i) => (
          <Route key={i} {...route.routeProps}>
            {route.component}
          </Route>
        ))}
        <Route {...PeopleAppRoute.routeProps} exact>
          <Rdrct to={peopleMembersUrl()} />
        </Route>
        <Route path={'/'}>
          <NotFoundBackgroundPageContent />
        </Route>
      </Switch>
    </BackgroundPage>
  )
}

export default People
